<template>
    <div id="editEmployee" class="content">
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-11">
                <form class="form" @submit.prevent="updateEmployee">
                    <!-- Image Preview -->
                    <div v-if="employee.photoPreview" class="preview-container">
                        <img :src="employee.photoPreview" alt="Preview" class="preview-image">
                    </div>

                    <!-- Upload Input -->
                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="photo">{{ label.photo }} <span style="color: blue;">(Max 15MB)</span></label>
                        </div>
                        <div class="col-sm-8">
                            <input ref="photoInput" type="file" class="form-control" id="photo" name="photo" accept="image/*" @change="onFileChange">
                        </div>
                        <div style="gap: 5px;">
                            <button type="button" class="btn btn-danger btn-sm mt-2" @click="removePhoto()">
                                Remove Photo
                            </button>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-2" >
                            <label class="control-label" for="full_name">{{ label.full_name }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" required id="full_name" name="full_name" v-model="employee.employee_name" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="staff_id">{{ label.staff_id }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control"  id="staff_id" name="staff_id" v-model="employee.staff_id" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="company">{{ label.company }}</label>
                        </div>

                        <div class="col-sm-8">
                            <select class="form-control" id="company" name="company" required v-model="employee.company_id">
                                <option v-bind:value="employee.company_id" selected>{{ employee.company_name }}</option>
                                <option v-for="(company, index) in companies" :key="index" v-bind:value="company.id">{{ company.display_name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="email">{{ label.email }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="email" class="form-control" required id="email" name="email" v-model="employee.email" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="New IC">{{ label.new_ic }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="new_id" name="new_ic" v-model="employee.card_id" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="created_at">{{ label.created_at }}</label>
                        </div>
                        <div class="col-sm-3">
                            <input type="date" class="form-control" id="created_at" name="created_at" required v-model="employee.created_at" >
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label" for="ended_at">{{ label.ended_at }}</label>
                        </div>
                        <div class="col-sm-3">
                            <input type="date" class="form-control" id="ended_at" name="ended_at" required v-model="employee.ended_at" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="id_number">{{ label.id_number }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="id_number" name="id_number" v-model="employee.id_number" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="passport">{{ label.passport }}</label>
                        </div>
                        <div class="col-sm-8">
                            <table class="table table-bordered">
                                <tr class="passport_number_table">
                                    <th>{{ label.passport_number }}</th>
                                    <th>{{ label.passport_v }}</th>
                                    <th>{{ label.passport_e }}</th>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control" id="passport_number" name="passport_number" v-model="employee.passport" ></td>
                                    <td><input type="date" class="form-control" id="valid_from" name="valid_from" v-model="employee.passport_issued"></td>
                                    <td><input type="date" class="form-control" id="expiry_date" name="expiry_date" v-model="employee.passport_expiry"></td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="form-group row">
                        <!--div class="col-sm-2">
                            <label class="control-label" for="can_batch">{{ label.can_batch }}</label>
                        </!--div>
                        <div class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_batch_options" id="batch_yes" value="1" v-model="employee.can_batch">
                                <label class="form-check-label" for="inlineRadio1">{{ label.batch_yes }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_batch_options" id="batch_no" value="0" v-model="employee.can_batch">
                                <label class="form-check-label" for="inlineRadio2">{{ label.batch_no }}</label>
                            </div>
                        </div -->

                        <div class="col-sm-2">
                            <label class="control-label" for="can_login">{{ label.can_login }}</label>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_login_options" id="login_yes" value="1" v-model="employee.can_login">
                                <label class="form-check-label" for="inlineRadio1">{{ label.login_yes }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_login_options" id="login_no" value="0" v-model="employee.can_login">
                                <label class="form-check-label" for="inlineRadio2">{{ label.login_no }}</label>
                            </div>
                        </div>

                        <div class="col-sm-2">
                            <label class="control-label" for="logged_in">{{ label.logged_in }}</label>
                        </div>

                        <div class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="logged_in_options" id="logged_in_yes" value="1" v-model="employee.logged_in">
                                <label class="form-check-label" for="inlineRadio1">{{ label.logged_in_yes }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="logged_in_options" id="logged_in_no" value="0" v-model="employee.logged_in">
                                <label class="form-check-label" for="inlineRadio2">{{ label.logged_in_no }}</label>
                            </div>
                        </div>
                    </div>

                     <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="can_geolocation">{{ label.can_geolocation }}</label>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="can_geolocation_options" id="can_geolocation_yes" value="1" v-model="employee.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.can_geolocation_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="enable_options" id="can_geolocation_no" checked="checked" value="0" v-model="employee.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.can_geolocation_no }}</label>
                                </div>
                            </div>
                        </div>

                    <div class="form-group row text-center">
                        <div class="col-sm-11">
                            <button type="submit" class="btn btn-primary" >SAVE</button>
                            <router-link :to="`/${$i18n.locale}/employee`"><button class="btn btn-primary">CANCEL</button></router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
          title: 'EDIT STAFF',
          label: {
                full_name: 'FULL NAME',
                staff_id: 'STAFF ID',
                company: 'COMPANY',
                email: 'EMAIL',
                new_ic: 'NEW IC',
                created_at: 'ACTIVE FROM',
                ended_at: 'ACTIVE UNTIL',
                id_number: 'ID',
                passport: 'PASSPORT',
                passport_number: 'NUMBER',
                passport_v: 'VALID FROM',
                passport_e: 'EXPIRY DATE',
                can_batch: 'MANAGE BATCH CLOCKING',
                batch_yes: 'YES',
                batch_no: 'NO',
                can_login: 'CAN LOGIN',
                login_yes: 'YES',
                login_no: 'NO',
                logged_in: 'LOGGED IN',
                logged_in_yes: 'YES',
                logged_in_no: 'NO',
                can_geolocation: 'GEOFENCING',
                can_geolocation_yes: 'YES',
                can_geolocation_no: 'NO',
                photo: 'PHOTO'
            },
            id: this.$route.params.id,
            employee: {
                employee_name: null,
                staff_id: null,
                company_id: null,
                company_name: null,
                email: null,
                card_id: null,
                created_at: null,
                ended_at: null,
                id_number: null,
                passport: null,
                passport_issued: null,
                passport_expiry: null,
                can_batch: [],
                can_login: [],
                logged_in: null,
                can_geolocation: [],
                photo: null,
                photoPreview : null
            },
            companies: [],
            validationMsg: '',
            status: '',
        }
    },

    methods: {
        loadEmployee() {
            var vm = this
            var moment = require('moment')

            axios.get(this.$store.getters.rootAPI + '/user/' + vm.id)
                .then(function (response) {
                    const employee = response.data.rec[0];

                    vm.employee.employee_name = employee.employee_name;
                    vm.employee.staff_id = employee.staff_id;
                    vm.employee.company_id = employee.company_id;
                    vm.employee.company_name = employee.company_name;
                    vm.employee.email = employee.email;
                    vm.employee.card_id = employee.card_id;
                    vm.employee.created_at = moment(employee.effective_at).format('YYYY-MM-DD');
                    vm.employee.ended_at = moment(employee.effective_till).format('YYYY-MM-DD');
                    vm.employee.id_number = employee.id_number;
                    vm.employee.passport = employee.passport;
                    vm.employee.passport_issued = employee.passport_issued ? moment(employee.passport_issued).format('YYYY-MM-DD') : null;
                    vm.employee.passport_expiry = employee.passport_expiry ? moment(employee.passport_expiry).format('YYYY-MM-DD') : null;
                    vm.employee.can_batch = employee.can_batch;
                    vm.employee.can_login = employee.can_login;
                    vm.employee.logged_in = employee.logged_in;
                    vm.employee.can_geolocation = employee.can_geolocation;

                    // initialize preview with backend blob image
                    vm.employee.photoPreview = employee.photo || null;
                    vm.employee.photo = null; // no new file selected yet
                })
                .catch(function (error) {
                    console.error('API Error:', error);
                    vm.status = 'An error occurred: ' + error;
                });
        },

        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                const maxSize = 15 * 1024 * 1024; // 15 MB in bytes
                if (file.size > maxSize) {
                    alert("File size exceeds 15 MB. Please upload a smaller image.");
                    this.$refs.photoInput.value = ""
                    this.employee.photoPreview = this.employee.photoPreview;
                    return;
                }
                this.employee.photo = file;
                const reader = new FileReader();
                reader.onload = e => {
                    this.employee.photoPreview = e.target.result; // preview new file
                };
                reader.readAsDataURL(file);
            }
        },

        removePhoto() {
            const payload = { employee_id: this.id };

            axios.post(this.$store.getters.rootAPI + '/employee/remove-photo/', payload)
                .then((response) => {
                    console.log('hahaha');
                    if (response.status !== 401) {
                        this.employee.photo = null;
                        this.employee.photoPreview = null;
                        this.$refs.photoInput.value = "";
                        alert(response.data.message || 'Photo removed successfully.');
                    } else {
                        alert(response.data.message || 'Failed to remove photo.');
                    }
                })
                .catch((error) => {
                    alert('An error occurred: ' + error);
                });
        },


        loadCompanies() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/companies')
            .then(function (response) {
                vm.companies = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        updateEmployee() {
            const vm = this
            let route = '/' + this.$i18n.locale + '/employee'

            const formData = new FormData()
            formData.append('display_name', vm.employee.employee_name)
            formData.append('staff_id', vm.employee.staff_id)
            formData.append('company_id', vm.employee.company_id)
            formData.append('email', vm.employee.email)
            formData.append('effective_at', vm.employee.created_at)
            formData.append('effective_till', vm.employee.ended_at)
            formData.append('card_id', vm.employee.card_id)
            formData.append('id_number', vm.employee.id_number)
            formData.append('passport', vm.employee.passport_number)
            formData.append('passport_issued', vm.employee.passport_issued)
            formData.append('passport_expiry', vm.employee.passport_expiry)
            formData.append('can_batch', vm.employee.can_batch)
            formData.append('can_login', vm.employee.can_login)
            formData.append('logged_in', vm.employee.logged_in)
            formData.append('can_geolocation', vm.employee.can_geolocation)
            if (vm.employee.photo) {
                formData.append('photo', vm.employee.photo) // real file here
            }

            axios.put(this.$store.getters.rootAPI + '/employee/'+ vm.id, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            }

         ).then(response => {   
            vm.status = response.data.status
            if(vm.status === 'success') {
                    vm.$router.push(route)

                } else if(response.data.errors && response.data.errors.length > 0) {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
            .catch(error => {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        },
    },
    created() {
        this.loadEmployee()
        this.loadCompanies()
    }
}
</script>

<style>
.preview-container {
  display: flex;
  justify-content: center;   /* center horizontally */
  margin-bottom: 15px;
}

.preview-container img {
  width: 150px;              /* fixed width */
  height: 150px;             /* fixed height */
  object-fit: cover;         /* crop image nicely */
  border-radius: 20px;       /* rounded corners */
  box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* subtle shadow */
}
</style>



// WEBPACK FOOTER //
// src/components/employee/EditEmployee.vue